'use strict';

export default function timeToDate(time) {
  if (time) {
    // HH:MM:SS
    // YYYY-MM-DDThh:mm:ss-03:00
    if (time.includes('T')) time = time.split('T')[1];
    const hours = parseInt(time.split(':')[0]);
    const minutes = parseInt(time.split(':')[1]);
    const now = new Date();
    const date = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDay(),
      hours,
      minutes
    );
    return new Date(date);
  }
  //return new Date()
  return null;
}
